import React, { useCallback } from "react";
import { FieldProps } from "react-jsonschema-form";
import styled from "styled-components";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import SelectGroup from "../../witadmin/CRUD/Common/SelectGroup";
import InputGroup from "../../witadmin/CRUD/Common/InputGroup";
import { ORGANIZATION_TYPE } from "../../witadmin/Common/constants";

const messages = defineMessages({
  iata: {
    id: "loyaltyOrganization.iata",
    defaultMessage: "iata",
  },
  type: {
    id: "loyaltyTier.type",
    defaultMessage: "amount",
  },
  agency: {
    id: "loyaltyOrganization.agency",
    defaultMessage: "agency",
  },
  company: {
    id: "loyaltyOrganization.company",
    defaultMessage: "company",
  },
});

const SelectGroupWrapper = styled.div`
  width: 200px;
`;

export function OrganizationType({ formData, onChange, schema, disabled, readonly }: FieldProps) {
  const intl = useIntl();
  const locked = Boolean(disabled || readonly);

  const handleChangeIata = useCallback(
    data => {
      onChange({
        ...formData,
        iata: data.event.target.value,
      });
    },
    [formData, onChange]
  );
  const handleChangeType = useCallback(
    (event, field) => {
      onChange({
        ...formData,
        organizationType: event.target.value,
      });
    },
    [formData, onChange]
  );
  return (
    <>
      <div>
        <label>
          <FormattedMessage {...messages.type} />
        </label>
        <SelectGroupWrapper>
          <SelectGroup
            value={formData?.organizationType || ORGANIZATION_TYPE.AGENCY}
            field={{
              fieldName: "type",
              widget: "selector",
              disabled: locked,
              optionDisplay: {
                AGENCY: { label: intl.formatMessage(messages.agency) },
                COMPANY: { label: intl.formatMessage(messages.company) },
              },
            }}
            onChange={({ event, field }) => handleChangeType(event, field)}
            errors={undefined}
            additionalFields={undefined}
            className={undefined}
          />
        </SelectGroupWrapper>
      </div>
      {(formData?.organizationType === ORGANIZATION_TYPE.AGENCY || !formData?.organizationType) && (
        <div>
          <label>
            <FormattedMessage {...messages.iata} />
          </label>
          <InputGroup
            type="string"
            value={formData?.iata || ""}
            field={{ fieldName: "iata" }}
            onChange={data => handleChangeIata(data)}
            disabled={locked}
            readOnly={locked}
          />
        </div>
      )}
    </>
  );
}
